module.exports = "import React from 'react';\r\nimport SvgIcon from '@versionone/ui/SvgIcon';\r\n\r\nclass CustomIcon extends React.Component {\r\n    render() {\r\n        return (\r\n            <SvgIcon>\r\n                <path\r\n                    d=\"M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S16.4,4,12,4z M17,13h-4.1v3.9h-2V13H7v-2h3.9V6.9h2V11H17V13z\"\r\n                />\r\n            </SvgIcon>\r\n        );\r\n    }\r\n}\r\n\r\nexport default function example() {\r\n    return (\r\n        <CustomIcon width={100} hoverColor=\"blue\" />\r\n    );\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ../~/raw-loader!../src/SvgIcon/examples/CustomSvgIcon.js
// module id = 1627
// module chunks = 0